<template>
  <div class="bottomCon">
    <div class="conText">
      <div class="conFirst">
        <img src="../assets/bottom/bottomIcon.png" alt="" />
        <p class="marP">
          友情链接： <a target="_blank" href="https://www.gmac.com/">GMAC</a> 
          <a target="_blank" href="https://www.cctalk.com/">CCtalk</a>
          <a target="_blank" href="https://www.1point3acres.com/bbs/"
            >一亩三分地</a
          >
          <a target="_blank" href="https://www.zhihu.com/">知乎</a>
          <a target="_blank" href="https://weibo.com/">微博</a>
          <a target="_blank" href="https://www.bilibili.com/">B站</a>
        </p>
        <p>联系地址： 上海市长宁区仙霞路137号盛高国际大厦302室</p>
        <p>官方邮箱：gmat@scoreupup.com</p>
        <p>ⓒ上海荷耳班提教育科技有限公司 沪ICP备2021020255号</p>
      </div>
      <div class="center">
        <div class="aboutGmat">
          <p class="aboutTit">关于GMAT</p>
          <p class="txtP" @click="goRouter('/introduction')">考试入门介绍</p>
          <p @click="goRouter('/hightScore')">高分学员分享</p>
          <p @click="goRouter('/matsList')">名科学习指南</p>
          <p @click="goRouter('/mostData')">最强王炸资料</p>
        </div>
        <div class="box">
          <p class="aboutTit">关于我们</p>
          <p class="txtP" @click="goRouter('/teacherteams')">师资团队</p>
          <p @click="goRouter('/founding')">创始之声</p>
        </div>
        <div class="box">
          <p class="aboutTit">联系我们</p>
          <router-link to="/forref"
            ><p id="thetest1" class="txtP">联系我们</p></router-link
          ><br />
          <router-link to="/learntest"
            ><p id="thetest2">加入备考群</p></router-link
          >
        </div>
      </div>
      <div class="aboutCode">
        <div class="left">
          <img
            :src="
              num == 1
                ? require('../assets/bottom/oneCode.png')
                : require('../assets/bottom/twoCode.png')
            "
            @load="cut"
          />
          <div style="text-align: center; color: #ffffff; margin-top: 17px">
            小助手微信
          </div>
        </div>
        <div class="right">
          <img src="../assets/bottom/erCode3.jpg" alt="" />
          <div style="text-align: center; color: #ffffff; margin-top: 17px">
            微信公众号
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      num: 0,
    };
  },
  methods: {
    goRouter(url) {
      this.$router.push(url);
    },
    cut() {
      setTimeout(() => {
        if (this.num == 0) {
          this.num = 1;
        } else {
          this.num = 0;
        }
      }, 500);
    },
  },
  mounted() {
    console.log(this.$route);
    if (this.$route.path === "/newest") {
      this.$router.push("/openClass/newest");
    } else if (this.$route.path === "/free") {
      this.$router.push("/openClass/free");
    }
    // this.cut();
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  activated() {},
};
</script>

<style scoped>
.bottomCon {
  width: 100%;
  height: 310px;
  background: #2c2d31;
  opacity: 1;
  position: absolute;
  min-width: 1250px;
}
.conText {
  width: 1200px;
  height: 170px;
  margin: 63px auto 0 auto;
  display: flex;
  justify-content: space-between;
}
.conFirst {
  cursor: default;
}
.conFirst img {
  width: 139px;
  height: 48px;
}
.marP {
  margin-top: 18px;
}
.conFirst p,
.conFirst p > a {
  text-decoration: none;
  color: #989898;
  font-size: 12px;
  opacity: 1;
  font-weight: 400;
  line-height: 30px;
  height: 30px;
}
.marP a:hover {
  color: #618aff;
}

.center {
  display: flex;
}
.aboutGmat {
  height: auto;
  /* margin-left: 80px; */
  font-weight: 400;
}
.aboutGmat p {
  height: 28px;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: #818182;
  opacity: 1;
  cursor: pointer;
  text-align: left;
}
.aboutTit {
  font-size: 18px !important;
  color: #ffffff !important;
  cursor: default !important;
}
.box p {
  height: 28px;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: #818182;
  opacity: 1;
  cursor: pointer;
  text-align: left;
}
.box a {
  text-decoration: none;
}

.txtP {
  margin-top: 33px;
}
.box {
  /* width: 103px; */
  margin-left: 60px;
  text-align: center;
}
.aboutCode {
  /* margin-left: 80px; */
  display: flex;
}
.aboutCode img {
  width: 130px;
  height: 130px;
}
.aboutCode .left {
  width: 130px;
  height: 170px;
}

.aboutCode .right {
  margin-left: 10px;
}

#thetest1 {
  margin-top: 30px;
}

#thetest2 {
  margin-top: -20px;
}
</style>



// WEBPACK FOOTER //
// src/components/bottomCon.vue